import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.updateSubmitButton()
  }

  formatInput() {
    this.inputTarget.value = this.inputTarget.value.replace(/\D/g, "")
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = this.inputTarget.value.length !== 6
    }
  }
}
